module.exports = __webpack_public_path__ + "static/img/Scon1@2x.1b99114e.png";